import { bl_mrp_job_order_bin_link_RowClass, bl_mrp_job_order_bin_link_RowInterface } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MrpJobOrderBinLinkContainerModel extends BaseContainerModel {
  bl_mrp_job_order_bin_link: bl_mrp_job_order_bin_link_RowInterface = new bl_mrp_job_order_bin_link_RowClass();
}